import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 shadow-sm' : 'bg-white/95'
      }`}
      style={{ borderBottom: '1px solid #E5E5E5' }}
    >
      <div className="flex items-center justify-between h-[72px] px-20">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-4">
            <h1 className="text-base font-medium tracking-[0.14em]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              プレミアム不動産
            </h1>
            <div className="w-px h-6 bg-[#CCCCCC]"></div>
            <span className="text-[11px] font-light text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>
              PREMIUM ESTATE
            </span>
          </div>
        </div>

        <div className="flex items-center gap-10">
          <button
            onClick={() => scrollToSection('about')}
            className="text-[13px] text-gray-700 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            会社概要
          </button>
          <span className="w-0.5 h-0.5 rounded-full bg-[#999999]"></span>
          <button
            onClick={() => scrollToSection('services')}
            className="text-[13px] text-gray-700 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            サービス
          </button>
          <span className="w-0.5 h-0.5 rounded-full bg-[#999999]"></span>
          <button
            onClick={() => scrollToSection('testimonials')}
            className="text-[13px] text-gray-700 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お客様の声
          </button>
          <span className="w-0.5 h-0.5 rounded-full bg-[#999999]"></span>
          <button
            onClick={() => scrollToSection('news')}
            className="text-[13px] text-gray-700 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お知らせ
          </button>
          <span className="w-0.5 h-0.5 rounded-full bg-[#999999]"></span>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-[13px] text-gray-700 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            採用情報
          </button>
          <span className="w-0.5 h-0.5 rounded-full bg-[#999999]"></span>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-[13px] text-gray-700 hover:text-gray-900 transition-colors"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            アクセス
          </button>
        </div>

        <button
          onClick={() => scrollToSection('contact')}
          className="w-[160px] h-[44px] border-2 border-[#2C2C2C] bg-white text-[#2C2C2C] text-[13px] font-medium hover:bg-[#2C2C2C] hover:text-white transition-all duration-300 whitespace-nowrap"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          お問い合わせ
        </button>
      </div>
    </nav>
  );
}
